import { stationName } from './sources.js';

/**
 * StationIndicator — "ON AIR" chip, top-right, desktop only (CSS-gated).
 *
 * Subscribes to an AudioManager and shows the current station name while
 * audio is enabled. Station changes get a quick static-flicker so the swap
 * reads like turning the dial.
 */
export class StationIndicator {
  constructor(audioManager) {
    this._audio = audioManager;
    this._lastSource = null;

    this.el = document.createElement('div');
    this.el.className = 'station-chip';
    this.el.setAttribute('role', 'status');
    this.el.setAttribute('aria-live', 'polite');
    this.el.innerHTML = `
      <span class="station-chip__dot" aria-hidden="true"></span>
      <span class="station-chip__label">ON AIR</span>
      <span class="station-chip__name"></span>
    `;
    document.body.appendChild(this.el);
    this._nameEl = this.el.querySelector('.station-chip__name');

    this._unsub = this._audio.onChange((state) => this._sync(state));
    const el = this._audio.audioElement;
    const setTuning = (on) => this.el.classList.toggle('station-chip--waiting', on);
    ['loadstart', 'waiting', 'stalled'].forEach((n) => el.addEventListener(n, () => setTuning(true)));
    ['playing'].forEach((n) => el.addEventListener(n, () => setTuning(false)));
    this._sync({ enabled: this._audio.isEnabled, source: this._audio.currentSource });
  }

  _sync({ enabled, source, tape = null }) {
    const visible = !!(enabled && (source || tape));
    this.el.classList.toggle('station-chip--visible', visible);
    this.el.classList.toggle('station-chip--tape', !!tape);
    this.el.querySelector('.station-chip__label').textContent = tape ? 'TAPE' : 'ON AIR';
    if (!visible) return;

    const name = tape ? tape.name : stationName(source);
    const key = tape ? `tape:${tape.name}` : source;
    if (key !== this._lastSource) {
      this._lastSource = key;
      this._nameEl.textContent = name;
      // Retrigger the tune-in flicker
      this.el.classList.remove('station-chip--tuning');
      void this.el.offsetWidth;
      this.el.classList.add('station-chip--tuning');
    }
  }

  destroy() {
    this._unsub?.();
    this.el.remove();
  }
}
